import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IParametersFormMeta } from '@Modules/admin/basicSettings/containers/formHandlers/center/update/parameters/ParametersMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';

type Props = {
  onSubmit: any,
  meta: IParametersFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const ParametersFormUI = ({
  onSubmit,
  isLoading,
  isSubmitting,
  meta,
}: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box as={'form'} onSubmit={handleSubmit(onSubmit)}>
      <CC.Flex gap={5} mb={5} flexWrap={{ md: 'wrap' }}>
        Dévise de référence
        <CC.Flex gap={4}>
          <CustomFormControl
            label={meta.refCurrencyAmount.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.refCurrencyAmount.name]}
          >
            <CustomTextInput
              meta={meta.refCurrencyAmount}
              register={register(meta.refCurrencyAmount.name)}
              hasError={errors[meta.refCurrencyAmount.name]}
            />
          </CustomFormControl>
          <CustomFormControl
            label={meta.refCurrency.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.refCurrency.name]}
          >
            <CustomInputSelect
              meta={meta.refCurrency}
              register={register(meta.refCurrency.name)}
              hasError={errors[meta.refCurrency.name]}
            />
          </CustomFormControl>
        </CC.Flex>
      </CC.Flex>

      <CC.SimpleGrid
        mb={10}
        columns={{ base: 1, md: 1, lg: 2 }}
        spacing={{ base: 5, lg: 8 }}
      >
        <CC.Card p={5}>
          <CC.Heading as="h3" size={'md'} fontWeight="normal" mb={3}>
            Traitement de fin de journée
          </CC.Heading>
          <CC.Stack gap={3}>
            <CustomFormControl
              label={meta.period.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.period.name]}
            >
              <CustomInputSelect
                meta={meta.period}
                register={register(meta.period.name)}
                hasError={errors[meta.period.name]}
              />
            </CustomFormControl>
            <CustomFormControl
              label={meta.hour.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.hour.name]}
            >
              <CustomTextInput
                meta={meta.hour}
                register={register(meta.hour.name)}
                hasError={errors[meta.hour.name]}
              />
            </CustomFormControl>

            <CustomFormControl
              label={meta.lastProcessing.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.lastProcessing.name]}
            >
              <CustomTextInput
                meta={meta.lastProcessing}
                register={register(meta.lastProcessing.name)}
                hasError={errors[meta.lastProcessing.name]}
              />
            </CustomFormControl>
          </CC.Stack>
        </CC.Card>

        <CC.Card p={5}>
          <CC.Heading as="h3" size={'md'} fontWeight="normal" mb={3}>
            Mes comptes
          </CC.Heading>
          <CC.Stack gap={3}>
            Dévise de référence
            <CC.Flex gap={4}>
              <CustomFormControl
                label={meta.currencyAmount.label}
                isLoading={isLoading}
                isInvalid={!!errors[meta.currencyAmount.name]}
              >
                <CustomTextInput
                  meta={meta.currencyAmount}
                  register={register(meta.currencyAmount.name)}
                  hasError={errors[meta.currencyAmount.name]}
                />
              </CustomFormControl>
              <CustomFormControl
                label={meta.currency.label}
                isLoading={isLoading}
                isInvalid={!!errors[meta.currency.name]}
              >
                <CustomInputSelect
                  meta={meta.currency}
                  register={register(meta.currency.name)}
                  hasError={errors[meta.currency.name]}
                />
              </CustomFormControl>
            </CC.Flex>
            <CustomFormControl
              label={meta.hpxAccount.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.hpxAccount.name]}
            >
              <CustomTextInput
                meta={meta.hpxAccount}
                register={register(meta.hpxAccount.name)}
                hasError={errors[meta.hpxAccount.name]}
              />
            </CustomFormControl>
            <CustomFormControl
              label={meta.bankAccount.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.bankAccount.name]}
            >
              <CustomTextInput
                meta={meta.bankAccount}
                register={register(meta.bankAccount.name)}
                hasError={errors[meta.bankAccount.name]}
              />
            </CustomFormControl>
            <CustomFormControl
              label={meta.accountBalance.label}
              isLoading={isLoading}
              isInvalid={!!errors[meta.accountBalance.name]}
            >
              <CustomTextInput
                meta={meta.accountBalance}
                register={register(meta.accountBalance.name)}
                hasError={errors[meta.accountBalance.name]}
              />
            </CustomFormControl>
          </CC.Stack>
        </CC.Card>
      </CC.SimpleGrid>

      {/* <CC.Card p={5}>
        <CC.Heading as="h3" size={'md'} fontWeight="normal" mb={3}>
          TVA
        </CC.Heading>
        <CC.TableContainer>
          <CC.Table variant="striped">
            <CC.Thead>
              <CC.Tr>
                <CC.Th colSpan={2}>TVA</CC.Th>
                <CC.Th colSpan={2}>Comptes HPX & Banque</CC.Th>
              </CC.Tr>
            </CC.Thead>
            <CC.Tbody>
              {Array(...Array(4)).map((elt, index) => (
                <CC.Tr key={index}>
                  <CC.Td>
                    <CC.Flex gap={5} alignItems={'center'}>
                      000
                    </CC.Flex>
                  </CC.Td>
                  <CC.Td>TVA item</CC.Td>
                  <CC.Td>HPX item</CC.Td>
                  <CC.Td>Bank item</CC.Td>
                </CC.Tr>
              ))}
            </CC.Tbody>
          </CC.Table>
        </CC.TableContainer>
      </CC.Card> */}

      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default ParametersFormUI;
